export const EDIT_LAST_NAME_FIND_USER = 'EDIT_LAST_NAME_FIND_USER';
export const RESET_FIND_USER_INPUT = 'RESET_FIND_USER_INPUT';
export const FIND_USER_SUCCESS = 'FIND_USER_SUCCESS';
export const FIND_USER_FAILED = 'FIND_USER_FAILED';
